import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    listaRevendas: {

    },
    listaRevendasContainer: {
        [theme.breakpoints.up('sm')]: {
            borderRight: `2px solid ${theme.palette.divider}`,
        },
        backgroundColor: theme.palette.background.default,
        borderRadius: theme.shape.borderRadius,
        position: 'relative',
    },
}))